import { CardFooter } from "reactstrap";
import { EdgeCancel, EdgeSubmit } from "../../../../Constant";
import { Btn } from "../../../../AbstractElements";

export const EdgesInputCardFooter = () => {
  return (
    <CardFooter className="text-end">
      <Btn color="primary" className="me-3" type="submit">
        {EdgeSubmit}
      </Btn>
      <Btn color="light" type="reset">
        {EdgeCancel}
      </Btn>
    </CardFooter>
  );
};
